export default __webpack_public_path__ + "img/dkjODNRs.7bce6aea.svg";